import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const menuButton = document.querySelector('.menu-icon');
  const menu = document.getElementById('main-menu');
  if (!menuButton || !menu) return;

  const closeMenu = () => {
    menuButton.classList.remove('is-active');
    menuButton.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-active');
    document.body.classList.remove('menu-open');

    $(menu)
      .find('li.open')
      .removeClass('open')
      .children('.submenu')
      .stop(true, true)
      .slideUp(0);
    $(menu).find('.dropdown-toggle').attr('aria-expanded', 'false');
  };

  menuButton.addEventListener('click', () => {
    const isOpen = menuButton.classList.toggle('is-active');
    menuButton.setAttribute('aria-expanded', String(isOpen));
    menu.classList.toggle('is-active', isOpen);
    document.body.classList.toggle('menu-open', isOpen);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('is-active')) {
      closeMenu();
      menuButton.focus();
    }
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  menu.querySelectorAll('[data-search-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', closeMenu);
  });

  const desktopMedia = window.matchMedia('(min-width: 1201px)');
  const handleDesktopChange = (event) => {
    if (event.matches) closeMenu();
  };

  if (desktopMedia.addEventListener) {
    desktopMedia.addEventListener('change', handleDesktopChange);
  } else {
    desktopMedia.addListener(handleDesktopChange);
  }

  mobileMenuHandler();

  /**
   * Mobile Burger menu
   */
  function mobileMenuHandler() {
    const $headerMenu = $('.header-menu');
    const $menuItems = $headerMenu.find('li.menu-item-has-children');

    $menuItems.each(function () {
      if (!$(this).children('.dropdown-toggle').length) {
        const itemLabel = $(this).children('a').first().text().trim();
        const $toggle = $('<button>', {
          class: 'dropdown-toggle',
          type: 'button',
          'aria-expanded': 'false',
          'aria-label': itemLabel,
        });

        $(this).append($toggle);
      }
    });

    $headerMenu.on('click', '.dropdown-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $parent = $(this).closest('li');
      const $submenu = $parent.children('.submenu');

      const $openSiblings = $parent.siblings('li.open');

      if ($openSiblings.length) {
        $openSiblings
          .removeClass('open')
          .children('.submenu')
          .stop(true, true)
          .slideUp(250);
        $openSiblings
          .children('.dropdown-toggle')
          .attr('aria-expanded', 'false');
      }

      const isOpen = !$parent.hasClass('open');
      $parent.toggleClass('open', isOpen);
      $(this).attr('aria-expanded', String(isOpen));
      $submenu.stop(true, true).slideToggle(250);
    });
  }
});
